import { FunctionComponent, Suspense, useContext } from 'react';
import { Redirect } from 'react-resource-router';
import Loader from 'components/common/loader/Loader';
import { PageError } from 'components/errors/PageError';
import { NotFound } from 'assets/images';
import { css } from '@compiled/react';
import { InitializedCommunityContext } from '../contexts/initialized-community';

const HomePage: FunctionComponent = () => {
  const { profileInternalId } = useContext(InitializedCommunityContext);

  return (
    <Suspense fallback={<Loader />}>
      {profileInternalId ? (
        <Redirect to={`/profile/${profileInternalId}`} />
      ) : (
        <div css={pageErrorWrapperStyles}>
          <PageError
            image={NotFound}
            heading="We couldn't find this profile"
            description="Either user is not logged in or it may have been deleted or there is a typo. Check the link, or visit our homepage."
            link="/user"
            linkText="Go home"
            // Note: UPP does not actually have a "Homepage" so this button will just bring the user back to this error page.
          />
        </div>
      )}
    </Suspense>
  );
};

const pageErrorWrapperStyles = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: 'calc(100vh - 200px)',
  boxSizing: 'border-box',
});

export default HomePage;
